import React from 'react';

const SinglePageItemArray = ({ title, value, type }) => {
  return (
    <div className={`single-page-item ${type}`}>
      <h4>
        {title}
      </h4>
      <div>
        {value && value.length ? 
          value.map(item => {
            return (
              <span key={item}>{item}</span>
            )
          }) :
          "N/A"
        }
      </div>
    </div>
  )
}

export default SinglePageItemArray;